import React, { createContext, useContext, useState } from 'react';
import { useQuery } from 'react-query';
import { getStatelist, getRequestSummary, viewRequestDetails } from '../api';
import { useUserContext } from './UserContext';

import ModalInformation from '../components/ModalInformation';
import { Button } from '../components/common';
import badRequestImage from '../images/bad_request.png';
import { pxToRem } from '../utils/dimensionConverter';
import { sendAnalyticsError } from '../libs/analytics';

const ReferralContext = createContext();
const { Consumer: UserConsumer, Provider } = ReferralContext;

export function ReferralProvider({ children }) {
  const { caseId, referralId, authRequest, continuationOfService } = useUserContext();
  const hasReferralId = (continuationOfService ? caseId : referralId) !== null;
  const getReferralData = continuationOfService ? viewRequestDetails : getRequestSummary;

  const referralData = continuationOfService
    ? { caseId, continuationOfService, referralId }
    : referralId;
  const [errorDisplay, setDisplayError] = useState(false);
  const stateList = useQuery('stateList', () => getStatelist(), {
    refetchOnWindowFocus: false,
  });
  const summaryData = useQuery('summaryData', () => getReferralData(referralData), {
    refetchOnWindowFocus: false,
    enabled: hasReferralId,
    initialData: () => {
      if (!hasReferralId) return { status: 'initial', isLoading: false };
    },
  });

  const handleReload = () => {
    sendAnalyticsError(
      continuationOfService ? 'COS' : 'New Request',
      'Oops! Something went wrong, please try again.'
    );
    setDisplayError(false);
    return summaryData.refetch();
  };

  const handleModalClose = () => {
    setDisplayError(false);
    window.location = `/home/index`;
  }

  return (
    <Provider
      value={{
        stateList,
        summaryData,
        authRequest,
        setDisplayError,
        caseId,
        isContinuation: continuationOfService,
      }}
    >
      {children}
      <ModalInformation
        size={pxToRem(394)}
        isOpen={errorDisplay}
        image={badRequestImage}
        imageSize={pxToRem(257)}
        onClose={handleModalClose}
        title={
          <span>
            Oops! Something went <br />
            wrong, please try again.
          </span>
        }
        description={
          <span>
            If you are still experiencing technical <br />
            difficulties, contact Portal Support.
          </span>
        }
        renderActions={
          <Button
            name="Try Again"
            brand="primary"
            height={pxToRem(44)}
            onClick={() => handleReload()}
          />
        }
      />
    </Provider>
  );
}
export default ReferralProvider;

export const useReferralContext = () => {
  const context = useContext(ReferralContext);
  return { ...context };
};
